import { render, staticRenderFns } from "./ApiRequests.vue?vue&type=template&id=5dc9f07c&scoped=true&"
import script from "./ApiRequests.vue?vue&type=script&lang=js&"
export * from "./ApiRequests.vue?vue&type=script&lang=js&"
import style0 from "./ApiRequests.vue?vue&type=style&index=0&id=5dc9f07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc9f07c",
  null
  
)

export default component.exports